<template>
  <iframe v-if="!this.terminated" id="scormContent" :src="this.path"
          class="h-100 w-100" allowfullscreen></iframe>
  <div v-else class="d-flex h-100 align-items-center justify-content-center">
    <div class="position-absolute activity-alert d-flex flex-column"
         :class="{'clear': !organization.darkMode}">
      <span class="h6 font-weight-bold">{{$t('app.activity.completed')}}</span>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import {
  FETCH_COURSES,
} from '@/store/actions.type';
import store from '@/store';
import { getToken } from '@/common/jwt.service';
import i18n from '@/i18n';

export default {
  name: 'AssignmentViewer',
  components: {
  },
  computed: {
    path() {
      return `${process.env.VUE_APP_API_URL}/api/front/v1/player/${this.course.organization_id}/${this.currentSession.attendee}/${this.course.glue}/assignment/player?token=${getToken()}&_locale=${i18n.locale}`;
    },
    ...mapGetters(['course', 'organization', 'currentSession']),
  },
  mounted() {
    this.terminated = false;
    window.addEventListener('message', this.receiveMessage);
  },
  watch: {
    $route() {
      this.terminated = false;
    },
  },
  beforeRouteUpdate() {
    this.terminated = false;
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  },
  data() {
    return {
      terminated: false,
    };
  },
  props: {
  },
  methods: {
    receiveMessage(e) {
      if (e.data === 'assignmentCommitted') {
        store.dispatch(FETCH_COURSES).then(() => {
          this.$Progress.finish();
        });
      }
    },
  },
};
</script>
